import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { fShortenNumber } from 'src/utils/format-number';

dayjs.extend(utc);

export type PredictionChartPointContext = {
  dataPointIndex?: number;
  seriesIndex?: number;
};

export type PredictionChartDateRange = {
  fromTime: string;
  toTime: string;
};

export const getPredictionLast30DayRange = (): PredictionChartDateRange => {
  const toTime = dayjs.utc().endOf('day').toISOString();
  const fromTime = dayjs.utc().subtract(29, 'day').startOf('day').toISOString();

  return {
    fromTime,
    toTime,
  };
};

export const formatPredictionXAxisLabel = (value: string | number) => dayjs(String(value)).format('DD/MM');

export const formatPredictionTooltipDate = (
  categories: string[],
  _value: string | number,
  context?: PredictionChartPointContext
) => {
  const dataPointIndex = context?.dataPointIndex ?? -1;
  const category = categories[dataPointIndex];

  if (!category) {
    return '';
  }

  return dayjs(category).format('YYYY-MM-DD');
};

export const formatPredictionTooltipValue = (value: string | number) => fShortenNumber(Number(value));

export const formatPredictionCurrencyTooltipValue = (
  value: string | number,
  context?: PredictionChartPointContext
) => {
  const formattedValue = formatPredictionTooltipValue(value);

  if ((context?.seriesIndex ?? 0) === 0) {
    return formattedValue;
  }

  return `$${formattedValue}`;
};
